<template>
    <kt-row>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="sign_key">
                   کلید رمزنگاری
                </kt-form-label>
                <kt-form-control
                    id="sign_key"
                    name="sign_key"
                    v-model="form_data.port_config.sign_key"
                    class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="gateway_id">
                  شناسه درگاه
                </kt-form-label>
                <kt-form-control
                        id="gateway_id"
                        name="gateway_id"
                        v-model="form_data.port_config.gateway_id"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        form_data: {
            required: true
        },
        port_config: {
            required: true
        }
    },
    methods:{
        processCertFile(e){
            this.form_data.certificate = event.target.files[0]
        },
    },
}
</script>

<style scoped>
    .label-file {
        border: 1px solid #ccc;
        width: fit-content;
        cursor: pointer;
        min-width: 200px;
    }
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
</style>